"use client";
import FeedList from "@/components/newsfeed/feed-list";
import Header from "@/components/newsfeed/header";
import WidgetDemo from "@/components/widget-demo";
import { useFeed } from "@/hooks/use-feed";
import { useEffect, useState } from "react";

export default function NewsPage() {
      const { project } = useFeed();
      const [isScrolled, setIsScrolled] = useState(false);

      useEffect(() => {
            const updateScroll = () => {
                  setIsScrolled(window.scrollY > 100);
            };
            window.addEventListener("scroll", updateScroll);
            return () => window.removeEventListener("scroll", updateScroll);
      }, []);

      return (
            <div className="flex flex-col w-full">
                  <Header title={project?.name} description={project?.description}
                        version="1.0.0"
                        logo={project?.logo}
                        backgroundCover={project?.cover}
                        fixed={isScrolled}
                        widgetMode={false}
                        textColor={project?.color ?? '#000000'} />
                  <FeedList className={`${isScrolled ? 'mt-38' : ''}`} />
                  <WidgetDemo subdomain="" widgetId="bb" />
            </div>
      );
}